<template>
  <section class="home-review-container">
    <h2 class="home-title">
      이미 많은 분들이 이용 중이에요
    </h2>

    <p class="home-sub-title">
      각기 다른 조작물을 사용하여 AB테스트를 하려는 경우에도, <br>
      대학원생의 예비조사 혹은 본조사에서도,<br>
      취업 면접을 준비하면서도,<br>
    </p>

    <div class="home-review-grid">
      <div class="review-card" v-for="review in displayedReviewList" :key="review.id">
        <div class="review-card-grade" aria-hidden="true">
          <img v-for="n in 5" :key="n" :src="n <= review.grade ? fullStar : emptyStar" width="18" alt="" />
        </div>

        <p class="review-card-content">{{ review.content }}</p>

        <div class="review-card-meta">
          <span class="review-card-survey" v-if="review.surveyTitle.length > 14">"{{ review.surveyTitle.substring(0, 15) }}..."</span>
          <span class="review-card-survey" v-else>"{{ review.surveyTitle }}"</span>
          <span class="review-card-dot">·</span>
          <span class="review-card-author">{{ review.username.substring(0, review.username.length - 1) + "*" }}님</span>
          <span class="review-card-dot">·</span>
          <span class="review-card-date">{{ review.createdAt }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import restar from '@/assets/home/review/restar.png'
import refullstar from '@/assets/home/review/refullstar.png'

export default {
  name: 'HomeReview',

  data() {
    return {
      reviewList: [],
      emptyStar: restar,
      fullStar: refullstar
    }
  },
  computed: {
    // 시안은 후기 4개만 카드로 보여준다 — 전체 후기 목록은 별도 화면 몫
    displayedReviewList() {
      return this.reviewList.slice(0, 4)
    }
  },
  mounted() {
    this.listReview()
  },
  methods: {
    async listReview() {
      try {
        const response = await axios.get("https://gosurveasy.co.kr/review/home")
        this.reviewList = response.data.homeReviewList
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.home-review-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.home-title {
  margin: 0 0 var(--space-3) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.home-sub-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 16px;
  font-weight: var(--font-weight-regular);
  color: var(--text-muted);
  text-align: left;
  line-height: 1.6;
}

.home-review-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.review-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-6);
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-lg);
  box-sizing: border-box;
  text-align: left;
}

.review-card-grade {
  display: flex;
  gap: 2px;
}

.review-card-content {
  margin: 0;
  font-size: 14px;
  color: var(--text-body);
  line-height: 1.6;
  flex-grow: 1;
}

.review-card-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-muted);
  padding-top: var(--space-3);
  border-top: 1px solid var(--ink-100);
}

.review-card-dot {
  color: var(--ink-300);
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }
}
</style>
